import React, { Component } from "react";
import Link from "../components/link";

import Isvg from "react-inlinesvg";
import Page from "../containers/page";

import { Player, Controls } from "@lottiefiles/react-lottie-player";

import { Container, Row, Col, Button } from "reactstrap";

import FormBuilder from "../components/forms/formBuilder";
import { required } from "../components/forms/validation";
import { API_ENDPOINT } from "../constants";

import logoLogin from "../assets/svg/logo_login.svg";
import logoDark from "../assets/images/logo-dark.png";
import shapeBlue from "../assets/svg/shape-blue.svg";
import shapeGreen from "../assets/svg/shape-green.svg";
import shapeYellow from "../assets/images/shape-yellow.png";
import bankIdIcon from "../assets/svg/bankid-vector-logo.svg";

// import FaceID from "../faceApi/loginComponent";
import LoginComponent from "../components/loginComponent";
// import BankIDModal_v2 from '../components/bankIDModal_v2';


/**
* Login page
* @author   Milan Stanojevic
*/
class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      promotedProjects: [],
      loginBankIdModal: true,
      ...props.initialData,
    };
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }

    for (let i = 0; i < this.props.loadData.length; i++) {
      this.props.loadData[i](
        window.fetch,
        this.props.lang,
        this.props[0].match
      ).then((data) => {
        this.setState(
          {
            ...data,
          },
          () => {
            this.props.updateMeta(
              this.props.generateSeoTags(this.state, this.props.lang)
            );
          }
        );
      });
    }

    // fetch(API_ENDPOINT + '/users/bankid/v2/start', {
    //   method: 'POST',
    //   headers: {
    //     'content-type': 'application/json'
    //   },
    //   body: JSON.stringify({ group: null })
    // }).then(res => res.json()).then((result) => {
    //   if (result.redirect_url) {
    //     this.setState({
    //       bankIdRedirectUrl: result.redirect_url
    //     })
    //   }
    // })

    // this.fetchBankId()
    window.addEventListener('message',
      (e) => {
        if (e.data == 'loggedin') {
          this.props.registerClinicGroupLogs({
            type: 'login',
            loginType: 'bankid'
          })
          this.props.verifyUser(() => {
            this.props[0].history.push('/');

          }, () => {
            // console.log(this.state.data)

            if (this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
              let arr = [];
              for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                arr.push(this.props.uData.clinicGroups[i]);
              }
              if (arr && arr.length) {
                this.props.changeGroup(arr[0]?._id);
                localStorage.setItem('groupAlias', arr[0].alias);
              }
              // if (arr.filter((item) => item && item._id == this.state.data._id).length == 0) {
              //   this.props.changeGroup(arr[0]._id);
              //   localStorage.setItem('groupAlias', arr[0].alias);
              // } else {
              //   this.props.changeGroup(this.state.data._id);
              // }
            }
            // else {
            //   this.props.changeGroup(this.state.data._id);
            // }


          });

        } else if (e.data == 'loggedin_newuser') {


          this.props.verifyUser(() => {
            this.props[0].history.push('/');
            // console.log(this.props.uData)
          }, () => {
            if (this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
              let arr = [];
              for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                arr.push(this.props.uData.clinicGroups[i]);
              }
              if (arr.filter((item) => item?._id == this.state.data?._id).length == 0) {
                this.props.changeGroup(arr[0]?._id)
                localStorage.setItem('groupAlias', arr[0].alias);
              } else {
                this.props.changeGroup(this.state.data?._id)
              }
            } else {
              this.props.changeGroup(this.state.data?._id)
            }




          });
        }
      }

      , false)
  }

  /**
  * Login function
  * @author   Milan Stanojevic
  */
  login = (data) => {

    if (API_ENDPOINT && (API_ENDPOINT.indexOf('localhost') == -1) && API_ENDPOINT.indexOf('qaapi-console') == -1) {
      if (!(API_ENDPOINT.indexOf('devapi.curoflow') != -1 && data.username == 'mista'))
        data.verificationCodeNeeded = true;
    }
    // if (typeof window != 'undefined' && localStorage.sessionId) {
    //     data.sessionId = localStorage.sessionId;
    // }

    fetch(API_ENDPOINT + "/users/login", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          if (result.error.text) {
            this.setState({
              error: result.error.text
            })
          } else {
            this.setState({
              error: result.error
            })
          }
        } else {
          if (result.sessionId) {
            localStorage.setItem('sessionId', result.sessionId)
          }
          try {
            if (result?.userData && typeof window !== 'undefined') {
              localStorage.setItem('userData', JSON.stringify(result?.userData));
            }
          } catch (err) {
            console.error('login user data err: ', err);
          }
          localStorage.removeItem('groupAlias');
          localStorage.setItem("authToken", result.token);
          localStorage.setItem("profile", "doctor");
          localStorage.setItem("time", Math.floor(Date.now() / 1000));
          this.props.registerLog("Logged in");
          this.props.verifyUser(() => {
            this.props.registerClinicGroupLogs({
              type: 'login',
              loginType: 'username',
            })
            if (typeof window != 'undefined' && (localStorage.getItem('groupAlias') == null || localStorage.getItem('groupAlias') == 'undefined')) {
              if (this.props.uData && this.props.uData.userLevel == 20 && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
                localStorage.setItem('groupAlias', this.props.uData.clinicGroups[0].alias)
              }
            }
            this.props[0].history.push("/my-data/account");

          });



        }
      });
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.uData) {
      this.props[0].history.push("/my-data/account");
    }
    // if (prevState.faceId != this.state.faceId && !this.state.faceId && this.state.loadingFaceId) {
    //   this.setState({ loadingFaceId: false })
    // }
  }
  // checkPhoto = (photo) => {
  //   this.setState({ loadingFaceId: true }, () => {
  //     let obj = { photo: photo }
  //     if (typeof window != 'undefined' && localStorage.sessionId) {
  //       obj.sessionId = localStorage.sessionId;
  //     }
  //     fetch(API_ENDPOINT + "/users/login/check/face-id", {
  //       method: "POST",
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //       body: JSON.stringify(obj),
  //     }).then((res) => res.json()).then((result) => {
  //       if (result && result.user) {
  //         this.setState({ faceId: null, faceIdUser: result.user, loadingFaceId: false })
  //       } else {
  //         this.setState({ loadingFaceId: false })
  //       }
  //     });

  //   })

  // }

  // fetchBankId = () => {
  //   fetch(API_ENDPOINT + `/users/bankid/v2/start/${this.props.lang == 'en' ? this.props.lang : 'sv'}/true`, {
  //     method: "GET",
  //     headers: {
  //       "content-type": "application/json",
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       if (result.redirect_url) {
  //         this.setState({
  //           bankIdRedirectUrl: result.redirect_url
  //         }, () => {
  //           setTimeout(() => {
  //             if (!this.props.uData) {
  //               this.fetchBankId()
  //             }
  //           }, 1000 * 60 * 4);
  //         })
  //       }
  //     });
  // }

  render() {
    return (
      <div>
        <div className="login-page login-hight-full">

          <LoginComponent {...this.props} mitID={true} netID={true} alias={'noGroupAlias'} doctorLogin={true} bankID={true} formLogin={true} _mainLogin={true} />
        </div>

      </div>
      // <div className="login-main-wrap">
      //   <div className="login-wrapper">
      //     {!this.props.userVerificationInProgress ? (
      //       <>
      //         <Isvg src={shapeBlue} className="shape-blue" />
      //         <Isvg src={shapeGreen} className="shape-green" />
      //         <img src={shapeYellow} className="shape-yellow" />
      //       </>
      //     ) : null}
      //     <div className="logo-header">
      //       <Isvg src={logoLogin} />
      //     </div>

      //     <div className="log-in">
      //       <Container fluid>
      //         <Row>
      //           <Col lg={{ size: 12 }}>
      //             {this.props.userVerificationInProgress ? (
      //               <div className="loader-wrap">
      //                 <Player
      //                   autoplay={true}
      //                   loop={true}
      //                   src="/lf30_editor_l5cxzdyf.json"
      //                   style={{
      //                     height:
      //                       typeof window != "undefined" &&
      //                         window.innerWidth < 768
      //                         ? "128px"
      //                         : "256px",
      //                     width:
      //                       typeof window != "undefined" &&
      //                         window.innerWidth < 768
      //                         ? "128px"
      //                         : "256px",
      //                   }}
      //                 ></Player>
      //               </div>
      //             ) : (
      //               <div className="panel" style={{
      //                 minWidth: typeof window != "undefined" &&
      //                   window.innerWidth < 768
      //                   ? null
      //                   : "508px",
      //               }}>
      //                 <div className="login-container">
      //                   <h4>{"Login".translate(this.props.lang)} </h4>

      //                   {/* {
      //                     !this.state.moreOptions && !this.state.faceId && !this.state.faceIdUser ?
      //                       this.state.bankIdRedirectUrl === null ?
      //                         <div className="loader-wrap">
      //                           <Player
      //                             autoplay={true}
      //                             loop={true}
      //                             src="/lf30_editor_l5cxzdyf.json"
      //                             style={{
      //                               height:
      //                                 typeof window != "undefined" &&
      //                                   window.innerWidth < 768
      //                                   ? "128px"
      //                                   : "256px",
      //                               width:
      //                                 typeof window != "undefined" &&
      //                                   window.innerWidth < 768
      //                                   ? "128px"
      //                                   : "256px",
      //                             }}
      //                           ></Player>
      //                         </div>
      //                         :

      //                         <>
      //                           {
      //                             !this.state._iframeLoaded ?


      //                               <div className="loader-wrap" style={{ height: 360 }}>
      //                                 <Player
      //                                   autoplay={true}
      //                                   loop={true}
      //                                   src="/lf30_editor_l5cxzdyf.json"
      //                                   style={{
      //                                     height:
      //                                       typeof window != "undefined" &&
      //                                         window.innerWidth < 768
      //                                         ? "128px"
      //                                         : "256px",
      //                                     width:
      //                                       typeof window != "undefined" &&
      //                                         window.innerWidth < 768
      //                                         ? "128px"
      //                                         : "256px",
      //                                   }}
      //                                 ></Player>
      //                               </div>
      //                               :
      //                               null
      //                           }

      //                           <iframe ref={(node) => this.bankIdIframe = node} onLoad={() => {
      //                             try {
      //                               if (this.bankIdIframe && this.bankIdIframe.contentWindow && this.bankIdIframe.contentWindow.location && this.bankIdIframe.contentWindow.location.href && this.bankIdIframe.contentWindow.location.href.indexOf('/bankid/v2') !== -1) {
      //                                 this.setState({
      //                                   _hideIframe: true
      //                                 })
      //                               }
      //                             } catch (e) { }
      //                             this.setState({ _iframeLoaded: true })
      //                           }} src={this.state.bankIdRedirectUrl} style={this.state._hideIframe ? { opacity: 0 } : { width: '100%', maxWidth: '550px', height: this.state._iframeLoaded ? 360 : 0, border: 0 }} />




      //                         </>

      //                       :
      //                       null

      //                   } */}
      //                   {
      //                     !this.state.moreOptions ?
      //                       <div className="login-form">
      //                         <BankIDModal_v2 {...this.props}/>
      //                       </div>

      //                       :
      //                       null
      //                   }
      //                   <div className={this.state.moreOptions && !this.state.faceId && !this.state.faceIdUser ? "login-more-options-wrap-show" : "login-more-options-wrap-hidden"}>
      //                     <div className="login-form">
      //                       <FormBuilder
      //                         dateFormat={this.props.dateFormat}
      //                         lang={this.props.lang}
      //                         onSubmit={(data) => this.login(data)}
      //                         buttonText={"Log in".translate(this.props.lang)}
      //                         fields={[
      //                           {
      //                             type: "row",
      //                             children: [
      //                               {
      //                                 type: "col",
      //                                 width: {
      //                                   lg: 12,
      //                                   sm: 12,
      //                                   xs: 12,
      //                                 },
      //                                 children: [
      //                                   {
      //                                     type: "text",
      //                                     name: "username",
      //                                     label: "Username".translate(
      //                                       this.props.lang
      //                                     ),
      //                                     validate: [
      //                                       required(
      //                                         "Username is required!".translate(
      //                                           this.props.lang
      //                                         )
      //                                       ),
      //                                     ],
      //                                   },
      //                                 ],
      //                               },
      //                               {
      //                                 type: "col",
      //                                 width: {
      //                                   lg: 12,
      //                                   sm: 12,
      //                                   xs: 12,
      //                                 },
      //                                 children: [
      //                                   {
      //                                     type: "password",
      //                                     name: "password",
      //                                     label: "Password".translate(
      //                                       this.props.lang
      //                                     ),
      //                                     validate: [
      //                                       required(
      //                                         "Password is required!".translate(
      //                                           this.props.lang
      //                                         )
      //                                       ),
      //                                     ],
      //                                   },
      //                                 ],
      //                               },
      //                             ],
      //                           },
      //                           {
      //                             type: "row",
      //                             children: [
      //                               {
      //                                 type: "col",
      //                                 width: {
      //                                   lg: 6,
      //                                   sm: 12,
      //                                   xs: 12,
      //                                 },
      //                                 children: [
      //                                   /*{
      //                                     type: "checkbox",
      //                                     name: "remember",
      //                                     beforeText: (
      //                                       <span className="login-checkbox"></span>
      //                                     ),
      //                                     label: (
      //                                       <span className="remember">
      //                                         {"Keep me logged in".translate(
      //                                           this.props.lang
      //                                         )}
      //                                       </span>
      //                                     ),
      //                                   },*/
      //                                 ],
      //                               },
      //                               {
      //                                 type: "col",
      //                                 width: {
      //                                   lg: 6,
      //                                   sm: 12,
      //                                   xs: 12,
      //                                 },
      //                                 children: [
      //                                   {
      //                                     type: "hidden",
      //                                     name: "forget",
      //                                     afterText: (
      //                                       <a
      //                                         href="/forgotpassword"
      //                                         className="forget"
      //                                       >
      //                                         {"Forgot password?".translate(
      //                                           this.props.lang
      //                                         )}
      //                                       </a>
      //                                     ),
      //                                   },
      //                                 ],
      //                               },
      //                             ],
      //                           },
      //                         ]}
      //                       ></FormBuilder>
      //                     </div>
      //                     <div className="login-divider">
      //                       <hr /> <span>{"or".translate(this.props.lang)}</span>{" "}
      //                       <hr />
      //                     </div>

      //                     {/* <div className="bank-id-button button-first">
      //                     <Button
      //                       onClick={() => {
      //                         fetch(API_ENDPOINT + "/users/bankid/v2/start", {
      //                           method: "GET",
      //                           headers: {
      //                             "content-type": "application/json",
      //                           },
      //                         })
      //                           .then((res) => res.json())
      //                           .then((result) => {
      //                             if (result.redirect_url) {
      //                               window.location.replace(
      //                                 result.redirect_url
      //                               );
      //                             }
      //                           });
      //                       }}
      //                     >
      //                       {"Log in with BankID".translate(this.props.lang)}
      //                     </Button>
      //                   </div> */}

      //                     <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
      //                       <div className="bank-id-button button-second" style={{ marginLeft: 0, width: '50%' }}>
      //                         <Button
      //                           onClick={() => {
      //                             fetch(API_ENDPOINT + "/users/netid/start/noGroupAlias", {
      //                               method: "GET",
      //                               headers: {
      //                                 "content-type": "application/json",
      //                               },
      //                             })
      //                               .then((res) => res.json())
      //                               .then((result) => {
      //                                 if (result.redirectUrl) {
      //                                   window.location.replace(result.redirectUrl);
      //                                 }
      //                               });
      //                           }}
      //                         >
      //                           {"Log in with SITHS".translate(this.props.lang)}
      //                         </Button>
      //                       </div>

      //                     </div>
      //                   </div>
      //                   {
      //                     this.state.faceId ?
      //                       <div>
      //                         <FaceID {...this.props}
      //                           checkPhoto={(photo) => {
      //                             this.setState({ scannedPhoto: photo }, () => {
      //                               if (!this.state.loadingFaceId) {
      //                                 this.checkPhoto(this.state.scannedPhoto);
      //                               }
      //                             })
      //                           }}

      //                         />
      //                       </div>
      //                       :
      //                       null
      //                   }
      //                   {
      //                     this.state.faceIdUser && !this.state.faceId ?
      //                       <div className="face-id-user-wrap" onClick={() => {
      //                         if (this.state.faceIdUser.token) {
      //                           if (typeof window != 'undefined') {
      //                             localStorage.removeItem('groupAlias');
      //                             localStorage.setItem("authToken", this.state.faceIdUser.token);

      //                             localStorage.setItem("time", Math.floor(Date.now() / 1000));
      //                             this.props.registerLog("Logged in");
      //                             this.props.verifyUser(() => {
      //                               this.props.registerClinicGroupLogs({
      //                                 type: 'login',
      //                                 loginType: 'username',
      //                               })
      //                               if (typeof window != 'undefined' && (localStorage.getItem('groupAlias') == null || localStorage.getItem('groupAlias') == 'undefined')) {
      //                                 if (this.props.uData && this.props.uData.userLevel == 20 && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
      //                                   localStorage.setItem('groupAlias', this.props.uData.clinicGroups[0].alias)
      //                                 }
      //                               }

      //                               if (this.props.uData && this.props.uData.userLevel != 1 && this.props.uData.userLevel != 2) {
      //                                 localStorage.setItem("profile", "doctor");
      //                               }
      //                               this.props[0].history.push("/");

      //                             });

      //                           }
      //                         }
      //                       }}>
      //                         <div className="user-image">
      //                           {
      //                             this.state.faceIdUser.profilePicture ?
      //                               <img src={API_ENDPOINT + this.state.faceIdUser.profilePicture} />
      //                               :
      //                               <img src={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABeCAYAAACq0qNuAAAABHNCSVQICAgIfAhkiAAABXdJREFUeF7tm09s1EUUxx8gm227rW23CNuWrsJuSGQ3EROoF8rBJmBP7UUMiRd6hKMe9cDFRDx4gJtea/QCXhpIuFgP1pqAyWLUbBUX264Wd4vttjRbieY76Rrb/f3/7e/3Ztc3SROSnZk383nf35uZN8Oe19+f/ZukhE5gj4APnbkyKOB5uAt4Ju4CXsBzEWCyKzFewDMRYDIrihfwTASYzIriBTwTASazongBz0SAyawoXsAzEWAyK4oX8EwEmMyK4gU8EwEms6J4Ac9EgMmsKF7A2xNoi+yj7FAnZZPPUk9nhAbjUdWovFalUqVKucIa3S+sUrlSte+MuUZTKB7AzxyP00imj9oj+2yRfZ1fodt3l7V2gPbge2MRujia/FfdttS3K2xUn9InXyxQ7uGq0yah1tMa/EA8SpfGjjhSuRm1qZkFmsuvhArViTFtwSO8vD2eot7OiJN5WNa5ejNPi6VN3/00sgNtwV8YOUyn0t2Wc50vrqvf8WXAUWYFi++Vz35sJDfffWkJPpWI0eWxFwwn96T6lG7MFilXWCX8u1bQZmI4oZxgVG7dW6Zbd3/3DaxRHWgJ3kztAH1t+mfTsAHVT44mKZXoqOOjm+q1BP/emy8aho5r0w9ovlixFB3gv3v+mGF7nWK9duDNwgwWR4BzUs69fJDOnXiurqpO4aZpwLuBZuY8N304cbCfOi0JHocuhJvdZS7/mKZmfvXDq2FtWxK8KN6DPsygLZQ26QOJ8R6Iumjid1fzzvljhmkG2dXYOMFsH4/E13WbffzF0SFKJ2L1+/jKFl359AcX7g+2qnYxHtO1OrkC/s2vlmhu/vEOMmgzPpwwzWLqtKPBwLUEj4E5ydXktw9TA/E2ywxmubJFV2/kd6QYgtWzfe/aglfZyYk09cb228/CpoZOsb02VG3BY4BIeF0eO2KZebTziuTj7QiZ/A74F04fNs06mnWLhNqU3EB5pL7dTN25ZvrUvatV3r1mBSdUpIB1vvTWOtTsdpd6ZZDsUn9IC9Ry71g8kfZFjh5/OgNvihjv7zvRu3VTKV5vlO5GpxV4XGz390YpfahDhREcitQbmXvLKpS4Ke2RZ2gkE6e2/Xsp/9u6euikU2EHD9jZoS46me6xfDuDJNnMd3/QUnmTFkpPDBmir9ShDtXf0f6OukMVbq+w8N4vrNFG9S9WP7CBT/fH6OxLB5SqvRR8Af9dRN32k/tllWa+L1F+yfoq0cvYnLQJHfypdI+6lmvEexknE7Srg6/g9rePQndAaOAH4230xulB10/x7MA16nc4YOrLRddriVf7gYPHInf2xAF1ANK9IPP5+WxRLehBl8DBT76apOzzXY7mgWM+DkA/FdfVk+uBviidTHUTwpOXgp0MFmK1gCe7HJ16YefjOw8pV/jTi0nHbQIFj/Dy1njKdjB4VArQVpPFYnz0YDuhz2hkb92ijIUWC+5ieZPmixvKebt3LnhXP5zupkzSWghw2Ed3Crbj9lMhUPCAdek146d4GDTyKbjQcLtH9zNhtMUXgAXe7EtCvMfjqSALC/iwFzIzgGZfZMuCh9JxFadD+XAyWzcMAR+CZwR8CJCNTPyvwGOf/E1+5ysBJu6G7/BbNtRwQXZqV8A7JdXgegK+wUCddtf04J2eXJ0CCateGNvdQA9QADXxSoLOHNc/QVZzKv7nyfXpB4FflAQOHhOC8jNDnWEJ1rOdlcqWyhmFcTsVCnjPJFq4oYBncq6AF/BMBJjMiuIFPBMBJrOieAHPRIDJrChewDMRYDIrihfwTASYzIriBTwTASazongBz0SAyawoXsAzEWAyK4oX8EwEmMyK4gU8EwEms6J4Ac9EgMmsKF7AMxFgMvsP3FL9zxFbsSwAAAAASUVORK5CYII='} />
      //                           }

      //                         </div>
      //                         <h6>{this.state.faceIdUser.name}</h6>
      //                       </div>
      //                       :
      //                       null
      //                   }
      //                   <div className="login-more-options" onClick={() => this.setState({ moreOptions: !this.state.moreOptions, faceId: null, faceIdUser: null })}>
      //                     {'Switch login method'.translate(this.props.lang)}

      //                   </div>
      //                   {/* {
      //                     typeof window != 'undefined' && localStorage.sessionId ?
      //                       <div className="login-more-options" onClick={() => this.setState({ faceId: !this.state.faceId })}>
      //                         {'Face ID'.translate(this.props.lang)}
      //                       </div>
      //                       :
      //                       null
      //                   } */}






      //                   {this.state.error ? (
      //                     <p style={{ color: 'red' }} className="error-message">
      //                       {this.state.error.translate(this.props.lang)}
      //                     </p>
      //                   ) : null}

      //                 </div>
      //               </div>
      //             )}
      //           </Col>
      //         </Row>
      //       </Container>
      //     </div>
      //   </div>
      // </div>
    );
  }
}

export default Page(LoginPage);
